import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ProjectId, User, UserType } from 'api/models';
import { ReactComponent as Crown } from 'assets/svgs/crown.svg';
import { ReactComponent as Hat } from 'assets/svgs/hat.svg';
import { ReactComponent as Trophy } from 'assets/svgs/trophy.svg';
import { BodyShort01 } from 'components/styles';
import { useProjectDetail } from 'data/projects';
import { useUser } from 'hooks/use-user';
import { getUserLabel } from 'utils/get-user-label';

const MemberTitle = styled.p`
  ${BodyShort01};
  color: var(--gray-100);
  display: flex;
  margin-bottom: 0;

  & .icon {
    margin-left: var(--spacing-03);
  }
`;

const Name = styled.span`
  white-space: nowrap;
  max-width: calc(100% - 32px);
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CrownGold = styled(Crown)`
  fill: #f1c21b;
`;

const TrophyGold = styled(Trophy)`
  fill: #f1c21b;
`;

const HatGold = styled(Hat)`
  fill: #f1c21b;
`;

export const ProjectMember: FC<{ projectId: number; member: User }> = ({
  projectId,
  member,
}) => {
  const { data: project } = useProjectDetail(ProjectId(projectId));
  const { user } = useUser();
  const customerChampionId = project?.customerChampion?.userId;
  const projectOwnerId = project?.projectOwner?.userId;
  const defaultCustomerPermissionSetType = [4, 5];

  return (
    <MemberTitle>
      <Name data-cy="memberName">{getUserLabel(member) || '-'}</Name>
      {projectOwnerId === member.userId && (
        <Tooltip title={<FormattedMessage id="projects.list.project_owner" />}>
          <span className="icon">
            <CrownGold />
          </span>
        </Tooltip>
      )}
      {customerChampionId === member.userId &&
        user.userType !== UserType.External && (
          <Tooltip
            title={<FormattedMessage id="projects.list.customer_champion" />}
          >
            <span className="icon">
              <TrophyGold />
            </span>
          </Tooltip>
        )}
      {member.permissionSet?.permissionSetType !== undefined &&
      !defaultCustomerPermissionSetType.includes(
        member.permissionSet?.permissionSetType,
      ) &&
      member.userId &&
      member.userType === UserType.External ? (
        <Tooltip
          title={
            <FormattedMessage
              id="projects.list.customer.assigned_permission"
              values={{
                permissionSetName:
                  member?.permissionSet?.permissionSetName ?? '',
                b: (chunks) => <strong>{chunks}</strong>,
              }}
            />
          }
        >
          <span className="icon">
            <HatGold />
          </span>
        </Tooltip>
      ) : null}
    </MemberTitle>
  );
};
